import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ActiveClientsModal = ({ isOpen, onClose, onApplyFilters }) => {
  const [filters, setFilters] = useState({
    activityLevel: '',
    lastActivityDays: '',
    engagementScore: '',
    propertyViews: '',
    responseRate: ''
  });

  const handleChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  const handleApply = () => {
    onApplyFilters?.(filters);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="العملاء النشطون" size="md" footer={null} icon={null} iconColor={null}>
      <div className="space-y-4">
        <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4 mb-4">
          <div className="flex items-center gap-2 text-green-400">
            <Icon name="UserCheck" size={20} />
            <span className="font-semibold">تصفية العملاء حسب مستوى النشاط</span>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">مستوى النشاط</label>
          <Select
            value={filters?.activityLevel}
            onChange={(e) => handleChange('activityLevel', e?.target?.value)}
          >
            <option value="">جميع المستويات</option>
            <option value="very-high">نشاط عالي جداً</option>
            <option value="high">نشاط عالي</option>
            <option value="medium">نشاط متوسط</option>
            <option value="low">نشاط منخفض</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">آخر نشاط خلال (أيام)</label>
          <Select
            value={filters?.lastActivityDays}
            onChange={(e) => handleChange('lastActivityDays', e?.target?.value)}
          >
            <option value="">جميع الفترات</option>
            <option value="1">آخر يوم</option>
            <option value="3">آخر 3 أيام</option>
            <option value="7">آخر أسبوع</option>
            <option value="14">آخر أسبوعين</option>
            <option value="30">آخر شهر</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">درجة التفاعل</label>
          <Select
            value={filters?.engagementScore}
            onChange={(e) => handleChange('engagementScore', e?.target?.value)}
          >
            <option value="">جميع الدرجات</option>
            <option value="90-100">ممتاز (90-100)</option>
            <option value="75-89">جيد جداً (75-89)</option>
            <option value="60-74">جيد (60-74)</option>
            <option value="0-59">متوسط (أقل من 60)</option>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">عدد معاينات العقارات</label>
          <Input
            type="number"
            placeholder="الحد الأدنى لعدد المعاينات"
            value={filters?.propertyViews}
            onChange={(e) => handleChange('propertyViews', e?.target?.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">معدل الاستجابة</label>
          <Select
            value={filters?.responseRate}
            onChange={(e) => handleChange('responseRate', e?.target?.value)}
          >
            <option value="">جميع المعدلات</option>
            <option value="high">عالي (أكثر من 80%)</option>
            <option value="medium">متوسط (50-80%)</option>
            <option value="low">منخفض (أقل من 50%)</option>
          </Select>
        </div>

        <div className="flex gap-3 pt-4">
          <Button onClick={handleApply} className="flex-1">
            <Icon name="Filter" size={18} className="ml-2" />
            عرض العملاء النشطون
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ActiveClientsModal;